export default "__VITE_ASSET__Cmc6SLFC__"